import DashedLineHr from './DashedLineHr'

export default DashedLineHr
